import { FC } from 'react'
import clsx from 'clsx'

import { formatNumber } from 'utils/formatNumber'

import styles from './price-block.module.scss'

interface IPriceBlock {
  price: string | number
  newPrice?: string | number
  percentage?: string | number
  wrapperModificator?: string
}

const PriceBlock: FC<IPriceBlock> = ({ price, newPrice, percentage, wrapperModificator }) => {
  return (
    <div
      className={clsx(styles.priceBlock, { [wrapperModificator as string]: wrapperModificator })}
    >
      <div className={clsx(styles.coursePrice, { [styles.oldPrice]: newPrice && percentage })}>
        {formatNumber(price)}
      </div>
      {newPrice && percentage && (
        <div className={clsx(styles.coursePrice, styles.discountPrice)}>
          <span>{formatNumber(newPrice)}</span>
          <div className={styles.discount}>
            <span>{`${percentage} %`}</span>
          </div>
        </div>
      )}
    </div>
  )
}

export default PriceBlock
